// Use relative path which will be proxied through package.json proxy setting
const BADGES_API_URL = '/api/badges';

export interface Badge {
  id: number;
  name: string;
  type: number;
}

/**
 * Fetch all available sport badges/types from Amovent API
 */
export const fetchBadges = async (): Promise<Badge[]> => {
  try {
    const response = await fetch(BADGES_API_URL, {
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
      }
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: Badge[] = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching badges:', error);
    throw error;
  }
};